<template>
    <div>
        <h2 class='subtitle is-dark'>
            マッチング相手選択画面
        </h2>
        <div v-if="isFirst&&isSecond&&isThird">開票までしばらくお待ちください....</div>
        <div v-else>
            <div v-if="entries.length> 1">気に入ったを選んでください</div>
            <div v-else>あなた以外誰もいません...</div>
        </div>
        <div class='box'>
            <!-- item.aは存在しないが、警告がでるので使用 -->
            <div  v-for="item in entries" :key="item.a">
                <div class="panel-block member" :class="changeColor(key)" v-for="(val, key) in item"
                :key="val" :id="key" @click="dialog(key, val)" v-if="uid !== key">
                    <span class="panel-icon">
                        <i class="fas fa-user" aria-hidden="true"></i>
                    </span>
                    <span>{{val}}</span>
                    <span class="right" v-if="key === isFirst">①</span>
                    <span class="right" v-if="key === isSecond">②</span>
                    <span class="right" v-if="key === isThird">③</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// なぜか動かないのでここで読み込む
import { Toast } from 'buefy/dist/components/toast'
import Choose from '@/views/Page/Dialog/Choose.vue'
export default {
    data(){
        return{
            uid: this.$store.state.uid,
            entries: [],
            db: this.$parent.$data.db,
            item: "",
            isFirst: "",  // 第1候補
            isSecond: "", // 第2候補
            isThird: "",  // 第3候補
        }
    },
    watch:{
        entries:{
            handler: (val)=>{
                // 最後にエントリーした人のtoastを表示
                let obj = val[val.length - 1];
                for(let key in obj){
                    Toast.open(`${obj[key]}がエントリーしました`);
                }
            },
        },
    },
    created(){
        // エントリー済みをウォッチ
        this.db.doc(this.$store.state.id).collection("name").orderBy("created").onSnapshot(snapShot=>{
            snapShot.docChanges().forEach(change=>{
                let tmp = {};
                tmp[change.doc.id] = change.doc.data().name;
                let isArray = false;
                for(let i in this.entries){
                    if(this.entries[i][change.doc.id]){
                        isArray = true;
                    }
                }
                if(!isArray){
                    this.entries.push(tmp);
                }
            });
        });
        // 自分の選択を表示
        this.db.doc(this.$store.state.id).collection("name").doc(this.$store.state.uid).get()
        .then(doc=>{
            let d = doc.data();
            this.isFirst  = d.select1;
            this.isSecond = d.select2;
            this.isThird  = d.select3;
        })
        .catch(error=>{this.$emit("error", error)})
    },
    methods:{
        error: function(error){
            console.log(error);
            this.$emit('alert', `エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`)
        },
        dialog: function(id, name){
            this.$modal.open({
                parent: this,
                component: Choose,
                props:{
                    id: id,
                    name:  name,
                    parentSelection: {
                        isFirst:  (this.isFirst === id)?  true: false,
                        isSecond: (this.isSecond === id)? true: false,
                        isThird:  (this.isThird === id)?  true: false,
                    }
                    
                },
                // Buefyのモーダルでは以下でイベントを渡す
                events: {
                    "confirm": (key, id)=>this.setSelection(key, id),
                }
            });
        },
        setSelection: function(key, id){
            // 重複を消す
            if(this.isFirst === id) this.isFirst = "";
            if(this.isSecond === id)this.isSecond = "";
            if(this.isThird === id) this.isThird = "";
            // セット
            if(key){
            this[key] = id;
            }
            this.send();
        },
        send: function(){
            this.db.doc(this.$store.state.id).collection("name").doc(this.$store.state.uid).set({
                select1: this.isFirst,
                select2: this.isSecond,
                select3: this.isThird
            },{merge: true})
            .catch(error=>{console.log(error);this.$emit("alert", `エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`)});
        },
        changeColor: function(id){
            let color = "";
            switch(id){
                case this.isFirst:
                color = "first";
                break;
                case this.isSecond:
                color = "second";
                break;
                case this.isThird:
                color = "third";
                break;
                default:
                color = "normal"
                break;
            }
            return color;
        }
    }
}
</script>

<style scoped>
.member       {
    cursor: pointer;
    position: relative;
    }
.first        {background: #ECACB5;}
.first:hover  {background: #E38692;}
.fisrt:active {background: #DA6272;}
.second       {background: #F9E3AA;}
.second:hover {background: #F6D580;}
.second:active{background: #F3C759;}
.third        {background: #A6E39D;}
.third:hover  {background: #81D674;}
.third:active {background: #5EC84E;}
.normal:hover {background: #eeeeee;}
.normal:active{background: #dddddd;}
.right{
    position: absolute;
    right: 15px;
}
</style>
